import { forwardRef } from 'react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';

import type { ComboboxSearchProps } from './combobox.types';

export const ComboboxSearch = forwardRef<HTMLInputElement, ComboboxSearchProps>(
  (
    {
      value,
      onChange,
      placeholder = 'Search...',
      autoFocus = true,
      size = 'md',
      'aria-label': ariaLabel = 'Search options',
    },
    ref
  ) => {
    const sizeStyles = {
      sm: { height: '32px', padding: '0 8px', fontSize: '12px' },
      md: { height: '40px', padding: '0 12px', fontSize: '14px' },
      lg: { height: '48px', padding: '0 16px', fontSize: '16px' },
    };

    return (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid #e5e7eb',
          backgroundColor: '#ffffff',
          ...sizeStyles[size],
        }}
      >
        <MagnifyingGlassIcon
          style={{ height: '16px', width: '16px', color: '#9ca3af', flexShrink: 0 }}
          aria-hidden="true"
        />
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
          style={{
            flex: 1,
            backgroundColor: 'transparent',
            border: '0',
            outline: 'none',
            padding: '0 8px',
            fontSize: '14px',
          }}
          aria-label={ariaLabel}
          role="searchbox"
          autoComplete="off"
          spellCheck={false}
        />
      </div>
    );
  }
);

ComboboxSearch.displayName = 'ComboboxSearch';
